import { createClient } from '@sanity/client'

export const client = createClient({
  projectId: '6h3eipmk', // replace with your Sanity project ID
  dataset: 'production',        // or your dataset name
  useCdn: true,                 // `true` for faster, cached reads
  apiVersion: '2025-01-01',     // use a fixed API date version
})
